module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title40"
    }
  }, [_c('h1', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title40"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781783408566_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781783408566_als01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("By the same author:")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781783408566_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_dedicationPage",
    attrs: {
      "href": "#/e9781783408566_ded01"
    }
  }, [_vm._v("Dedication")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781783408566_ack01"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgements")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783408566_fm02"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Leslie Robinson & Stanley Sheead")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783408566_fm03"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Biltcliffe – Photographers")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781783408566_p01"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Townships")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408566_c01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Skelmanthorpe")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408566_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Clayton West")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408566_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("High Hoyland")])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781783408566_bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Supplementary Chronology")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-077bff4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408566_toc01.vue
// module id = 69
// module chunks = 0